import { memo } from 'react'
import { useFlag } from '@unleash/proxy-client-react'
import { Button, List, ListItem, ListItemIcon, Stack, styled } from '@mui/material'
import { HelpOutline, PersonOutline } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { drawerVar } from '../../../../../providers/apollo/cache'

const AccountList = styled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  borderTop: `1px solid ${theme.palette.customGrey[200]}`,
  '.MuiListItem-root': {
    padding: 0
  },
  '.MuiButton-root': {
    gap: '8px',
    padding: 0,
    color: '#727C8C',
    fontSize: '0.875rem',
    fontWeight: 500,
    '.MuiListItemIcon-root': {
      minWidth: 0,
      color: '#727C8C',
      '.MuiSvgIcon-root': {
        maxWidth: '20px'
      }
    },
    '&:hover': {
      background: 'transparent',
      color: theme.palette.primary.main,
      '.MuiListItemIcon-root': {
        color: theme.palette.primary.main
      }
    }
  }
}))

function AccountMenu() {
  const navigate = useNavigate()
  const enabledNewBucketSwitcher = useFlag('enabledNewBucketSwitcher')

  const handleAccountNavigation = () => {
    navigate('/settings#profile')
    drawerVar(null)
  }

  return (
    <Stack sx={{ mt: '4px', paddingBottom: '4px' }}>
      <AccountList>
        {enabledNewBucketSwitcher ? (
          <ListItem>
            <Button onClick={handleAccountNavigation}>
              <ListItemIcon>
                <PersonOutline />
              </ListItemIcon>
              My Account
            </Button>
          </ListItem>
        ) : (
          <ListItem>
            <Button variant="text" data-test="pendo-rc-button">
              <ListItemIcon>
                <HelpOutline />
              </ListItemIcon>
              Support
            </Button>
          </ListItem>
        )}
      </AccountList>
    </Stack>
  )
}

export default memo(AccountMenu)
